// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-input-wrapper[data-v-763f6bca] {
  position: relative;
  width: 100%;
  padding: 9px 34px;
  min-height: min-content;
  transition-property: width;
  transition-duration: .25s;
  border: none;
  background: var(--search-input-bgcolor);
  border-radius: 20px;
  height: 40px;
}
.search-input-wrapper[data-v-763f6bca]:before {
  position: absolute;
  content: "\\f002";
  font-family: "Font Awesome 5 Pro";
  color: var(--btns-block-color);
  transform: translate(-20px, -50%);
  top: 52%;
}
.search-input-wrapper .search-input[data-v-763f6bca] {
  transition-property: width;
  transition-duration: .25s;
  background: var(--bg-color2);
  display: flex;
  color: var(--custom-textarea-color);
  font-size: 16px;
  width: 100%;
  line-height: 1.2em;
  margin: auto 0.6em;
  border: none;
  outline: none;
  background-color: transparent;
}
.search-input-wrapper .search-input.title[data-v-763f6bca] {
  color: var(--elem-green-color);
}
.search-input-wrapper .btns-block[data-v-763f6bca] {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  top: 9px;
  right: 9px;
  align-items: center;
  color: var(--btns-block-color);
  height: 25px;
}
.search-input-wrapper .btns-block .clearSearch[data-v-763f6bca] {
  font-size: 18px;
  cursor: pointer;
  margin: 0px 4px;
}
.search-input-wrapper .btns-block .filter-btn[data-v-763f6bca] {
  font-size: 16px;
  cursor: pointer;
  margin: -1px 4px 0px 4px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomSearch.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,QAAQ;AACV;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".search-input-wrapper[data-v-763f6bca] {\n  position: relative;\n  width: 100%;\n  padding: 9px 34px;\n  min-height: min-content;\n  transition-property: width;\n  transition-duration: .25s;\n  border: none;\n  background: var(--search-input-bgcolor);\n  border-radius: 20px;\n  height: 40px;\n}\n.search-input-wrapper[data-v-763f6bca]:before {\n  position: absolute;\n  content: \"\\f002\";\n  font-family: \"Font Awesome 5 Pro\";\n  color: var(--btns-block-color);\n  transform: translate(-20px, -50%);\n  top: 52%;\n}\n.search-input-wrapper .search-input[data-v-763f6bca] {\n  transition-property: width;\n  transition-duration: .25s;\n  background: var(--bg-color2);\n  display: flex;\n  color: var(--custom-textarea-color);\n  font-size: 16px;\n  width: 100%;\n  line-height: 1.2em;\n  margin: auto 0.6em;\n  border: none;\n  outline: none;\n  background-color: transparent;\n}\n.search-input-wrapper .search-input.title[data-v-763f6bca] {\n  color: var(--elem-green-color);\n}\n.search-input-wrapper .btns-block[data-v-763f6bca] {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  display: flex;\n  top: 9px;\n  right: 9px;\n  align-items: center;\n  color: var(--btns-block-color);\n  height: 25px;\n}\n.search-input-wrapper .btns-block .clearSearch[data-v-763f6bca] {\n  font-size: 18px;\n  cursor: pointer;\n  margin: 0px 4px;\n}\n.search-input-wrapper .btns-block .filter-btn[data-v-763f6bca] {\n  font-size: 16px;\n  cursor: pointer;\n  margin: -1px 4px 0px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
